import { axiosWithAuth } from "helpers";
import { NoteService } from "types";

export const merchantDealNotesService: NoteService = {
	addNote,
	deleteNote,
	editNote,
	getNotes,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getNotes(merchantId, { page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
		},
		url: `${API_URL}/api/merchants/${merchantId}/notes`,
	};

	return axiosWithAuth(options);
}

function addNote(merchantId, note) {
	const options = {
		method: "POST",
		data: note,
		url: `${API_URL}/api/merchants/${merchantId}/notes/add`,
	};

	return axiosWithAuth(options);
}

function editNote(merchantId, note) {
	const options = {
		method: "PUT",
		data: note,
		url: `${API_URL}/api/merchants/${merchantId}/notes/${note?.id}`,
	};

	return axiosWithAuth(options);
}

function deleteNote(merchantId, note) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/merchants/${merchantId}/notes/${note.id}`,
	};

	return axiosWithAuth(options);
}
